"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSameGraph = void 0;
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const swapDependencyIdsForSlugs = ({ artifacts, dependencies, }) => {
    const artifactIdMap = new Map();
    artifacts.forEach((artifact) => {
        (0, common_1.finleyAssert)(!artifactIdMap.has(artifact.id), `Duplicate artifact id detected: ${artifact.id}`);
        artifactIdMap.set(artifact.id, artifact.artifactSlug);
    });
    return dependencies.map(({ inputArtifactId, outputArtifactId }) => {
        const inputSlug = artifactIdMap.get(inputArtifactId);
        const outputSlug = artifactIdMap.get(outputArtifactId);
        (0, common_1.finleyAssert)(inputSlug, `input artifact slug does not exist inputArtifactId:${inputArtifactId}`);
        (0, common_1.finleyAssert)(outputSlug, `output artifact slug does not exist outputArtifactId:${outputArtifactId}`);
        return { inputArtifactId: inputSlug, outputArtifactId: outputSlug };
    });
};
const cleanArtifacts = (artifacts) => artifacts.map((artifact) => {
    // we want to explicitly destructure here, in the event extra properties
    // exist at runtime (like timestamps)
    const { artifactSlug, creditFacilitySlug, loanProductSlug, type, externalFilename, configuration, } = artifact;
    return {
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug,
        type,
        externalFilename,
        configuration,
    };
});
const sortArtifacts = (artifacts) => (0, remeda_1.sortBy)(artifacts, [(artifact) => artifact.artifactSlug, 'asc']);
const sortDependencies = (dependencies) => (0, remeda_1.sortBy)(dependencies, [(dep) => dep.inputArtifactId, 'asc'], [(dep) => dep.outputArtifactId, 'asc']);
const stringifyGraph = ({ artifacts, dependencies, }) => `${JSON.stringify(artifacts)}-${JSON.stringify(dependencies)}`;
// determines if two graphs are functionally the same (ignoring UUIDs)
const isSameGraph = ({ graph1, graph2, }) => {
    const graph1Artifacts = (0, remeda_1.pipe)(graph1.artifacts, cleanArtifacts, sortArtifacts);
    const graph2Artifacts = (0, remeda_1.pipe)(graph2.artifacts, cleanArtifacts, sortArtifacts);
    const graph1Deps = (0, remeda_1.pipe)(graph1, swapDependencyIdsForSlugs, sortDependencies);
    const graph2Deps = (0, remeda_1.pipe)(graph2, swapDependencyIdsForSlugs, sortDependencies);
    const graph1Str = stringifyGraph({
        artifacts: graph1Artifacts,
        dependencies: graph1Deps,
    });
    const graph2Str = stringifyGraph({
        artifacts: graph2Artifacts,
        dependencies: graph2Deps,
    });
    return graph1Str === graph2Str;
};
exports.isSameGraph = isSameGraph;
//# sourceMappingURL=sameGraph.js.map